import { z } from 'zod';

import { MaturityHistoryItemId, PrincipalModificationId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';

export const MaturityHistoryItem = z.object({
  id: MaturityHistoryItemId,
  type: z.enum(['initial', 'manualUpdate', 'constructionToPermanent', 'modification']),
  createdAt: zodJSInstantDate,
  maturityDate: zodJSPlainDate,
  modificationId: PrincipalModificationId.optional(),
});
export type MaturityHistoryItem = z.infer<typeof MaturityHistoryItem>;

export const MaturityConfig = z.object({
  dIsMaturing: z.boolean(),
  history: z.array(MaturityHistoryItem),
});
export type MaturityConfig = z.infer<typeof MaturityConfig>;
